(function ($) {

    $('.js-custom-select').select2({
        minimumResultsForSearch: -1,
        width: 'resolve'
    });

})(jQuery);